<template>
    <GroupBookingToggle v-if="deviceCanManageGroupBookings" />

    <NoResults v-if="cartIsEmpty"
               icon="far fa-cart-shopping"
               lang="CART.NO_ITEMS" />
</template>

<script>
import GroupBookingToggle from '@/epos/vue/components/GroupBookings/GroupBookingToggle';
import NoResults from '@/vue/components/NoResults';
import { container } from '@/container';

/**
 * Everything Vue renders inside the sell view's left side, which is otherwise still Angular
 * (src/partials/sell/cart.html).
 */
export default {
    name: 'SellLeft',

    components: {
        GroupBookingToggle,
        NoResults,
    },

    data() {
        return {
            /**
             * This is controlled by the watcher that checks the current cart's value.
             *
             * @type {boolean}
             */
            cartIsEmpty: false,
        };
    },

    computed: {
        deviceCanManageGroupBookings() {
            return this.$store.state.currentDevice.manageGroupBookings;
        },
    },

    watch: {
        // The CartService is the only thing that knows whether the cart is empty, so read it from there rather than
        // keeping a copy in Vuex, and use the store only to know when the cart changed.
        '$store.state.cart.modified': {
            handler() {
                this.cartIsEmpty = container.cartService.isEmpty();
            },
            immediate: true,
        },
    },
};
</script>
